// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__80elo","main":"Button_main__QsYBp","secondary":"Button_secondary__p86vC"};